<template>
  <step :context="context" image="/images/rocket.svg" @back="$emit('back')" @submit="submit">
    <template #guideTitle>Let's get to know each other.</template>
    <template #guideDescription>
      Please enter your business details and contact information.
      We need this information to generate a user profile for you.
      <div v-if="withTaxId">
        <br>
        The Tax Number/ID/EIN is required in order to register your brand to 10DLC Communication channel.<br/><br/>
        What is 10 DLC?<br/><br/>
        As part of establishing an industry standard to protect consumers from unwanted messages,
        the Cellular Telecommunications Industry Association (CTIA) has collaborated with major wireless service providers
        to adopt "Messaging Principles and Best Practices."
        Carriers developed 10DLC regulations to help eliminate spam and clean up SMS.
        The newest standards for text messaging, these rules help turn texting into a commercially viable channel.

        As of October 1, 2021, carriers such as AT&T and T-Mobile began directly throttling unregistered SMS traffic
        and announced their intent to impose fines on companies that do not comply with the new rules.
      </div>
    </template>
    <template #formTitle>Business Details</template>
    <template #form>
      <v-form class="form" v-model="valid" ref="form">
        <!-- General -->
        <div class="general">
          <!--          <v-text-field-->
          <!--            v-model="model.general.businessName"-->
          <!--            label="Business Name"-->
          <!--            placeholder=" "-->
          <!--            :rules="[rules.required]"-->
          <!--          />-->
          <!-- <v-text-field
            v-model="model.general.address"
            label="Address"
            placeholder=" "
            :rules="[rules.required]"
          /> -->
          <v-text-field
              v-model="model.general.revelURL"
              label="Revel URL"
              placeholder="https://business-id.revelup.com"
              hint="https://business-id-replace-me.revelup.com"
              :rules="[rules.required]"
          />
          <v-text-field
              v-model="model.general.businessWebsite"
              placeholder="business website url"
          >
            <template v-slot:label>
              Business  <strong>Website</strong> URL
            </template>
          </v-text-field>
          <v-text-field
              v-model="model.general.email"
              label="Email"
              placeholder=""
              :rules="[rules.required, rules.email]"
              validate-on-blur
          />
          <div v-if="withTaxId">
            <v-text-field
                v-model="model.general.taxId"
                label="Tax Number/ID/EIN"
                :rules="[rules.required]"
            />
          </div>
          <div v-if="reseller || resellerNoComm">
            <v-text-field
                v-model="model.general.legalCompanyName"
                label="Legal Company Name"
                :rules="[rules.required]"
            />
          </div>
          <div v-if="reseller">
            <v-text-field
                v-model="model.general.country"
                label="Country"
                :rules="[rules.required]"
            />
          </div>
          <div v-if="reseller">
          <v-text-field
                v-model="model.general.zipCode"
                label="Zip Code"
                :rules="[rules.required]"
            />
          </div>
          <div v-if="reseller">
            <v-text-field
                v-model="model.general.streetAddress"
                label="Street Address"
                :rules="[rules.required]"
            />
          </div>
          <div v-if="reseller">
            <v-text-field
                v-model="model.general.city"
                label="Street Address"
                :rules="[rules.required]"
            />
          </div>
          <div v-if="reseller">
            <v-text-field
                v-model="model.general.state"
                label="State"
                :rules="[rules.required]"
            />
          </div>
          <div v-if="reseller">
            <v-text-field
                v-model="model.general.phone"
                label="Phone No."
                :rules="[rules.required]"
            />
          </div>
          <div v-if="withTaxId" class="hint">Please upload your tax registration document
            <v-file-input
                @change="addFile()"
                v-model="file"
                :placeholder="getPlaceHolder()"
                small-chips
                show-size
                accept="image/png, image/jpeg, application/pdf"
                :rules="[rules.fileRequired]"
            />
          </div>
          <div v-if="resellerNoComm">
            <v-text-field
              v-model="model.general.businessName"
              label="Business Name (DBA)"
              placeholder=" "
              :rules="[rules.required]"
              />
          </div>
          <!-- <v-text-field
            v-model="model.general.numberOfLocations"
            label="No. of Locations"
            placeholder=" "
            :rules="[rules.required]"
          /> -->
        </div>
        <!-- Establishments -->
        <!-- <v-radio-group
          class="establishments"
          v-model="model.establishments.value"
          label="List the establishments you wish to activate."
          :row="!mobile"
          hide-details
          :rules="[rules.required]"
        >
          <v-radio label="All" value="all" />
          <custom-radio label="Specific branches" value="select" :indent="mobile"/>
          <div v-if="model.establishments.value == 'select'">
            <div class="general" v-for="(establisment, index) in model.establishments.selection" :key="index">
              <v-text class="caption" v-if="mobile && model.establishments.selection.length >1">{{index+1}}</v-text>
              <v-text-field
                v-model="establisment.name"
                placeholder="Branch Name"
                :name="`model.establishments.selection[${index}][name]`"
              />
              <v-text-field
                v-model="establisment.id"
                placeholder="Branch Id"
                :name="`model.establishments.selection[${index}][id]`"
                  :rules="[!model.establishments.value == 'select' || rules.required]"
              />
            </div>
            <v-btn small icon @click="addBranch">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-btn small icon @click="removeBranch">
                <v-icon>mdi-minus</v-icon>
            </v-btn>
          </div> 
        </v-radio-group>-->
        <!-- Loyalty program -->
        <v-radio-group v-if="!resellerNoComm"
            v-model="model.existingLoyaltyProgram"
            label="Do you have an existing loyalty program?"
            row
            hide-details
            :rules="[rules.required]"
        >
          <v-radio label="Yes, Revel's" value="revel"/>
          <v-radio label="Yes, Other" value="other"/>
          <v-radio label="No" value="no"/>
          <div class="hint">We will migrate your existing members onto the new platform.</div>
        </v-radio-group>
      </v-form>
    </template>
  </step>
</template>

<script>
import Step from "../Step";
import displayMixin from "@/mixins/display";
import axios from "axios";

const EMAIL_PATTERN = /\S+@\S+\.\S+/;

export default {
  props: ["context"],
  mixins: [displayMixin],
  components: {
    Step
  },
  created() {
    this.withTaxId = this.$parent.$attrs.withTaxId;
    this.reseller = this.$parent.$attrs.reseller;
    this.resellerNoComm = this.$parent.$attrs.resellerNoComm;
  },
  data() {
    return {
      valid: false,
      rules: {
        required: v => !!v || "Field is required",
        fileRequired: value => !!value || !!this.model.general.fileUrl || 'File is required!',
        email: v => EMAIL_PATTERN.test(v) || "Email must be valid"
      },
      withTaxId: false,
      reseller: false,
      fileData: null,
      file: null,
      model: {
        general: {
          businessName: null,
          address: null,
          email: null,
          phone: null,
          revelURL: null,
          businessWebsite: null,
          taxId: null,
          numberOfLocations: null,
          fileUrl: null,
          fileName: null,
          legalCompanyName: null,
          country: null,
          zipCode: null,
          streetAddress: null,
          city: null,
          state: null,

        },
        // establishments: {
        //   value: null,
        //   selection: [
        //     {
        //       id: '',
        //       name: ''
        //     }
        //   ],
        // },
        existingLoyaltyProgram: null,
        ...this.context.submittedData
      }
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate())
        this.$emit("done", {...this.$data.model});
    },
    addFile() {
      const reader = new FileReader();
      this.upload = function (event) {
        this.fileData = event.target.result;
        try {
          axios.post(`/api/uploadFile`, {file: this.fileData}).then(response => {
            this.model.general.fileUrl = response.data.fileUrl;
            this.model.general.fileName = this.file.name;
          }).catch(error => {
            console.log(`Failed getting url for file: ${error}`);
            this.model.general.fileData = null;
          });
        } catch (e) {
          console.log(`Failed uploading file: ${e}`);
          this.model.general.fileData = null;
        }
      };
      this.upload = this.upload.bind(this);
      reader.addEventListener("load", this.upload, false);

      if (this.file) {
        reader.readAsDataURL(this.file);
      }
    },
    getPlaceHolder(){
      return this.model.general.fileName? this.model.general.fileName : ""
    },
    // addBranch () {
    //   this.$data.model.establishments.selection.push({
    //       id: '',
    //       name: ''
    //   })
    // },
    // removeBranch () {
    //   this.$data.model.establishments.selection.pop();
    // },
  }
};
</script>

<style lang="scss" scoped>
.form {
  .general {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 60px;

    #app.mobile & {
      grid-template-columns: 1fr;
    }
  }

  #app.desktop & {
    ::v-deep .establishments {
      .v-input--radio-group__input > .v-label {
        margin-bottom: -4px !important;
      }

      .v-text-field {
        .v-input__slot {
          width: 200px;
        }
      }
    }
  }
}
</style>
